import React from 'react';
import styled, { css } from 'styled-components';
import { Transition } from 'react-transition-group';
import {
  ENTERED,
  ENTERING,
  EXITED,
  EXITING,
} from 'react-transition-group/Transition';
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default ({ children, isVisible = true, ...props }) => (
  <Transition in={isVisible} timeout={500}>
    {state => (
      <Container {...props} state={state} childrenCount={React.Children.count(children)}>
        {children}
      </Container>
    )}
  </Transition>
);

const Container = styled.div`
  overflow: hidden;
  visibility: ${({ state }) => state === EXITED ? 'hidden' : null};
  transition: all 500ms ease;
	border-top: ${themeResponsiveProperty(null, '1px solid rgba(0,0,0,.5)')};

  ${({ state, childrenCount }) => {
    switch (state) {
      case ENTERING:
      case ENTERED:
        return css`
          max-height: ${childrenCount * 6.25}rem;
          border-top-color: ${themeResponsiveProperty(null, 'rgba(0,0,0,.5)')};
        `;

      case EXITING:
      case EXITED:
      default:
        return css`
          max-height: 0;
          border-top-color: rgba(0,0,0,0);
        `;
    }
  }}

  ${props => props.theme.isMobile && css`
    width: 100%;
    padding: 0 1rem;

    a {
      font-weight: normal;
      font-size: .8125rem;
    }
  `};
`;
